import { client } from './client'

export interface Event {
  event_id: string
  timestamp: string
  identification: {
    visitor_id: string
  }
}

export interface VisitorsResponse {
  visitorId: string
  events: Event[]
}

export async function getVisitorsHistory(visitorId: string) {
  return client<VisitorsResponse>(`fingerprint/visitors/${visitorId}`)
}
